import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Card, CardContent } from '../components/ui/Card';

export function About() {
  const { t } = useTranslation();

  return (
    <div className="container-app py-12">
      <div className="mx-auto max-w-3xl">
        <h1 className="mb-8 text-3xl font-bold sm:text-4xl">
          {t('about.title', 'About this project')}
        </h1>

        <Card variant="bordered">
          <CardContent className="prose dark:prose-invert max-w-none">
            <h2>{t('about.what_is_this', 'What is this?')}</h2>
            <p>
              Do You Like This Work? is a study on aesthetic perception and AI bias.
              We show you images and ask if you like them. After you vote, we reveal
              whether the work was created by a human artist or generated by AI.
            </p>

            <h2>{t('about.why', 'Why?')}</h2>
            <p>
              As AI-generated imagery becomes more prevalent, we want to understand:
            </p>
            <ul>
              <li>How do people perceive AI-generated vs. human-created art?</li>
              <li>What aesthetic qualities influence our preferences?</li>
              <li>Are there biases in how we judge AI art before and after knowing its origin?</li>
              <li>How does context and disclosure affect our appreciation of creative work?</li>
            </ul>

            <h2>{t('about.how_it_works', 'How it works')}</h2>
            <p>
              Each image in our collection has been carefully verified and categorized.
              We collect your votes along with anonymized data about your reasoning.
              No personally identifiable information is stored - we use browser fingerprinting
              to prevent duplicate votes while preserving your privacy.
            </p>

            <h2>{t('about.data', 'What happens with the data?')}</h2>
            <p>
              All voting data is anonymized and will be used for research purposes.
              We may publish aggregate statistics and findings to help understand how
              people perceive and value AI-generated vs. human-created artwork.
            </p>

            <h2>{t('about.contribute', 'How to contribute')}</h2>
            <p>
              You can help by:
            </p>
            <ul>
              <li>Voting on images you haven't seen before</li>
              <li>Suggesting new images for the collection</li>
              <li>Sharing this project with others interested in art and AI</li>
            </ul>

            <h2>{t('about.credits', 'Credits')}</h2>
            <p>
              This project was created as an open-source study on aesthetic perception.
              All images are properly attributed to their original creators and sources.
              If you believe an image is incorrectly attributed, please contact us.
            </p>
          </CardContent>
        </Card>

        <div className="mt-6 text-center">
          <Link
            to="/"
            className="inline-flex items-center gap-1 text-sm text-gray-900 hover:text-accent dark:text-gray-200"
          >
            <ArrowLeft className="h-4 w-4" aria-hidden="true" />
            {t('common.back', 'Back')}
          </Link>
        </div>
      </div>
    </div>
  );
}
